<nav class="navbar navbar-expand-lg bg-body-tertiary cpal">
  <div class="container-fluid">
    <a class="navbar-brand" href="#"><img class="img-fluid" src="assets/img/logo.png" alt="Logo"></a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link" aria-current="page" routerLink="home">Home</a>
        </li>
        <li class="nav-item" *ngIf="isLoggedIn">
          <a class="nav-link" routerLink="estado-situacion">Estado Situación</a>
        </li>
        <li class="nav-item" *ngIf="isLoggedIn">
          <a class="nav-link" routerLink="historial">Historial Solicitudes</a>
        </li>
      </ul>
      <div class="d-flex ms-auto">
        <ul class="navbar-nav mb-2 mb-lg-0">
          <li class="nav-item mt-2 margin-icons" *ngIf="isLoggedIn">
            <a class="nav-link position-relative" routerLink="conversaciones-listado">
                <i class="fas fa-envelope fa-2xl"></i>
                <span
                    *ngIf="unreadMessagesCount > 0"
                    class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                >
                {{ unreadMessagesCount }}
                </span>
            </a>
        </li>
            <li class="nav-item mt-2 margin-icons">
                <a class="nav-link" routerLink="mi-perfil" *ngIf="isLoggedIn"> <i class="fa-solid fa-circle-user fa-2xl"></i></a>
            </li>
            <li class="nav-item ">
                <a class="nav-link" *ngIf="!isLoggedIn" (click)="auth.loginWithRedirect()">Iniciar Sesión</a>
            </li>
            <li class="nav-item mt-2">
                <a class="nav-link active" *ngIf="isLoggedIn" (click)="logout()"><i class="fa-solid fa-right-from-bracket fa-2xl"></i></a>
            </li>
        </ul>
    </div>
    
    </div>
  </div>
</nav>
